// polyfills
import 'babel-polyfill';
import 'element-closest';

// source
import './web';
import './configureWeb';
import './configurePartialUpdate';
//import './configureTurbolinks';

// css
import '../css/main.less';


// WEBPACK FOOTER //
// ./config/module-publish/resources/js/index.js